import { useState } from 'react';
import { faqs } from '@/mocks/sports';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">快速了解米乐体育平台</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <h4 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.question}</h4>
                  <i
                    className={`ri-arrow-down-s-line text-lg transition-transform duration-200 flex-shrink-0 ${
                      openIndex === index ? 'rotate-180 text-primary-500' : 'text-foreground-400'
                    }`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-200/70 pt-4">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}